import React, { useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import { Field } from "react-final-form";
import Autocomplete from "../../../../components/Autocomplete";
import {
  SECONDARY_SCHOOL_LEVEL,
  SECONDARY_SCHOOL_TYPE,
} from "../../../academic/constants";
import { INTAKES, IntakeType, PROGRAM_TYPES } from "../../constants";
import { useQuery } from "react-query";
import useProgramQueriesSecondary from "../../hooks/useProgramQueriesSecondary";

const useStyles = makeStyles(() => ({
  formControl: {
    marginTop: 21,
  },
}));

const FilterFormSecondary = () => {
  const classes = useStyles();

  const { fetchCountriesContainingPrograms } = useProgramQueriesSecondary();

  const { isLoading, isFetching, data } = useQuery<any>(
    "countriesContainingProgramsSecondary",
    fetchCountriesContainingPrograms,
  );

  const intakes = useMemo(
    () => INTAKES.filter((intake) => intake.id !== IntakeType.OUTDATED),
    [],
  );

  return (
    <>
      <div className={classes.formControl}>
        <Field
          fullWidth
          multiple={true}
          name="secondary.countries"
          label="Country"
          placeholder="Country"
          options={data?.data}
          loading={(isFetching || isLoading).toString()}
          disabled={isLoading || isFetching}
          disableCloseOnSelect
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="secondary.schoolLevel"
          label="School Level"
          placeholder="School Level"
          options={SECONDARY_SCHOOL_LEVEL}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="secondary.schoolType"
          label="School Type"
          placeholder="School Type"
          options={SECONDARY_SCHOOL_TYPE}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="secondary.programType"
          label="Program Type"
          placeholder="Program Type"
          options={PROGRAM_TYPES}
          component={Autocomplete}
        />
      </div>
      <div className={classes.formControl}>
        <Field
          fullWidth
          name="secondary.intake"
          label="Intake"
          placeholder="Intake"
          options={intakes}
          component={Autocomplete}
        />
      </div>
    </>
  );
};

export default React.memo(FilterFormSecondary);
